import { store } from '../../../../store.js';

const PRICE_PER_USER = 35;
const EXTRA_COUNCIL_PRICE = 37.5;

const handleName = (packageName, userCount, isNational) => {
  return `${packageName} - ${userCount} ${userCount > 1 ? 'Users' : 'User'} - ${
    isNational ? 'National' : '3 Zones'
  }`;
};

const getPrice = (productPackage, state, discountPercentage) => {
  const { productsConfig } = store.getState().packageSelection;
  const price =  productsConfig['cordell-connect']?.configuration?.packages[productPackage]?.package_price ;
   ;

  if (productPackage === 'lite' && state) {
    if(discountPercentage){
      const discountedPrice = productsConfig['cordell-connect'].configuration.packages[productPackage].geography.metro[state].price * discountPercentage
      const discontedPriceTotal = Math.round((productsConfig['cordell-connect'].configuration.packages[productPackage].geography.metro[state].price - discountedPrice) * 100 )/ 100
      return discontedPriceTotal;
    }else{
      return productsConfig['cordell-connect'].configuration.packages[productPackage].geography.metro[state].price;
    }
  }
};

const handleExtraUser = (
  productList,
  product,
  packageName,
  userCount,
  defaultUserCount,
  pricePerUser,
  minimumInitialTerm,
  discountPercentage
) => {
  if (userCount > defaultUserCount) {
    const extraUserCount = userCount - defaultUserCount;
    product.item_id = product.item_name = `${packageName} - Add On - Extra User`;
    if(discountPercentage){
      const discountedPrice = pricePerUser  * discountPercentage
      const discontedPriceTotal = Math.round((pricePerUser - discountedPrice) * 100) / 100
      product.price = discontedPriceTotal;
    }else{
      product.price = pricePerUser
    }
    product.quantity = minimumInitialTerm * extraUserCount;
  }
  productList.push({ ...product });
};

const handleZoneAddons = (
  productList,
  product,
  packageName,
  productPackage,
  states,
  minimumInitialTerm,
  discountPercentage
) => {
  if (states.length > 0) {
    states.map((state) => {
      product.item_id = product.item_name = `${packageName} - 2 Users - ${state.toUpperCase()}`;
      product.price = getPrice(productPackage, state, discountPercentage);
      product.quantity = minimumInitialTerm;
      product.item_category3 = state.toUpperCase();
      productList.push({ ...product });
    });
  }
};

const handleCordellConnectConfig = (quote, quoteConfig, category) => {
  const { headLine: packageName, minimumInitialTerm } = quote;
  const {
    geography,
    number_of_users: userCount,
    package: productPackage
  } = quoteConfig.configuration;
  let product = {};
  const productList = [];

  let defaultUserCount = 2;

  // Default Values
  product.item_brand = 'Cordell Connect';
  product.item_category = category;
  product.item_variant = packageName;
  product.coupon = null;
  const discountPercentage = quote.provisioningInfo?.discountPercentage
    ? quote.provisioningInfo?.discountPercentage / 100
    : null;

  product.item_id = product.item_name = handleName(packageName, defaultUserCount, geography.national);
  product.price = getPrice(productPackage, null, discountPercentage);
  product.quantity = minimumInitialTerm;
  product.item_category2 = minimumInitialTerm.toString();

  if (productPackage === 'lite') {
    handleZoneAddons(
      productList,
      product,
      packageName,
      productPackage,
      geography.states,
      minimumInitialTerm,
      discountPercentage
    );
  }

  // Handle Extra User (compare to defaultUserCount)
  handleExtraUser(
    productList,
    product,
    packageName,
    userCount,
    defaultUserCount,
    PRICE_PER_USER,
    minimumInitialTerm,
    discountPercentage
  );
  return productList;
};

export { handleCordellConnectConfig };
